import { Field } from "../types";

export const copy: Field["copy"] = (block) => ({
  ...block,
  config: {
    ...block.config,
    id: undefined,
  },
});
